"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repulser = void 0;

var Enums_1 = require("../../../Enums");

var Utils_1 = require("../../../Utils");

var Vector_1 = require("../../../Core/Particle/Vector");

var ExternalInteractorBase_1 = require("../../../Core/ExternalInteractorBase");

var Repulser =
/*#__PURE__*/
function (_ExternalInteractorBa) {
  _inherits(Repulser, _ExternalInteractorBa);

  function Repulser(container) {
    _classCallCheck(this, Repulser);

    return _possibleConstructorReturn(this, _getPrototypeOf(Repulser).call(this, container));
  }

  _createClass(Repulser, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events,
          divs = events.onDiv,
          divRepulse = (0, Utils_1.isDivModeEnabled)(Enums_1.DivMode.repulse, divs);

      if (!(divRepulse || events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode,
          clickMode = events.onClick.mode;
      return (0, Utils_1.isInArray)(Enums_1.HoverMode.repulse, hoverMode) || (0, Utils_1.isInArray)(Enums_1.ClickMode.repulse, clickMode) || divRepulse;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _this = this;

      var container = this.container,
          options = container.actualOptions,
          mouseMoveStatus = container.interactivity.status === Utils_1.Constants.mouseMoveEvent,
          events = options.interactivity.events,
          hoverEnabled = events.onHover.enable,
          hoverMode = events.onHover.mode,
          clickEnabled = events.onClick.enable,
          clickMode = events.onClick.mode,
          divs = events.onDiv;

      if (mouseMoveStatus && hoverEnabled && (0, Utils_1.isInArray)(Enums_1.HoverMode.repulse, hoverMode)) {
        this.hoverRepulse();
      } else if (clickEnabled && (0, Utils_1.isInArray)(Enums_1.ClickMode.repulse, clickMode)) {
        this.clickRepulse();
      } else {
        (0, Utils_1.divModeExecute)(Enums_1.DivMode.repulse, divs, function (selector, div) {
          return _this.singleSelectorRepulse(selector, div);
        });
      }
    }
  }, {
    key: "singleSelectorRepulse",
    value: function singleSelectorRepulse(selector, div) {
      var _this2 = this;

      var container = this.container,
          query = document.querySelectorAll(selector);

      if (!query.length) {
        return;
      }

      query.forEach(function (item) {
        var elem = item,
            pxRatio = container.retina.pixelRatio,
            pos = {
          x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
          y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
        },
            repulseRadius = elem.offsetWidth / 2 * pxRatio,
            area = div.type === Enums_1.DivType.circle ? new Utils_1.Circle(pos.x, pos.y, repulseRadius) : new Utils_1.Rectangle(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio),
            divs = container.actualOptions.interactivity.modes.repulse.divs,
            divRepulse = (0, Utils_1.divMode)(divs, elem);

        _this2.processRepulse(pos, repulseRadius, area, divRepulse);
      });
    }
  }, {
    key: "hoverRepulse",
    value: function hoverRepulse() {
      var container = this.container,
          mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var repulseRadius = container.retina.repulseModeDistance;
      this.processRepulse(mousePos, repulseRadius, new Utils_1.Circle(mousePos.x, mousePos.y, repulseRadius));
    }
  }, {
    key: "processRepulse",
    value: function processRepulse(position, repulseRadius, area, divRepulse) {
      var _a;

      var container = this.container,
          query = container.particles.quadTree.query(area),
          repulseOptions = container.actualOptions.interactivity.modes.repulse;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = query[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var particle = _step.value;

          var _ref = (0, Utils_1.getDistances)(particle.position, position),
              dx = _ref.dx,
              dy = _ref.dy,
              distance = _ref.distance,
              velocity = ((_a = divRepulse === null || divRepulse === void 0 ? void 0 : divRepulse.speed) !== null && _a !== void 0 ? _a : repulseOptions.speed) * repulseOptions.factor,
              repulseFactor = (0, Utils_1.clamp)((0, Utils_1.calcEasing)(1 - distance / repulseRadius, repulseOptions.easing) * velocity, 0, repulseOptions.maxSpeed),
              normVec = Vector_1.Vector.create(distance === 0 ? velocity : dx / distance * repulseFactor, distance === 0 ? velocity : dy / distance * repulseFactor);

          particle.position.addTo(normVec);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "clickRepulse",
    value: function clickRepulse() {
      var container = this.container;

      if (!container.repulse.finish) {
        if (!container.repulse.count) {
          container.repulse.count = 0;
        }

        container.repulse.count++;

        if (container.repulse.count === container.particles.count) {
          container.repulse.finish = true;
        }
      }

      if (container.repulse.clicking) {
        var repulseDistance = container.retina.repulseModeDistance,
            repulseRadius = Math.pow(repulseDistance / 6, 3),
            mouseClickPos = container.interactivity.mouse.clickPosition;

        if (mouseClickPos === undefined) {
          return;
        }

        var range = new Utils_1.Circle(mouseClickPos.x, mouseClickPos.y, repulseRadius),
            query = container.particles.quadTree.query(range);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = query[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var particle = _step2.value;

            var _ref2 = (0, Utils_1.getDistances)(mouseClickPos, particle.position),
                dx = _ref2.dx,
                dy = _ref2.dy,
                distance = _ref2.distance,
                d = Math.pow(distance, 2),
                velocity = container.actualOptions.interactivity.modes.repulse.speed,
                force = -repulseRadius * velocity / d;

            if (d <= repulseRadius) {
              container.repulse.particles.push(particle);
              var vect = Vector_1.Vector.create(dx, dy);
              vect.length = force;
              particle.velocity.setTo(vect);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else if (container.repulse.clicking === false) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = container.repulse.particles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _particle = _step3.value;

            _particle.velocity.setTo(_particle.initialVelocity);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        container.repulse.particles = [];
      }
    }
  }]);

  return Repulser;
}(ExternalInteractorBase_1.ExternalInteractorBase);

exports.Repulser = Repulser;